import React, { useState, useEffect } from "react"

import { Row, Col } from "antd"
import hiveLeft from "images/landing-page/hive-left.png"
import hiveRight from "images/landing-page/hive-right.png"
import "aos/dist/aos.css"
import { Select } from "formik-antd"
import Request from "../../helpers/Request"
import { useMediaQuery } from "react-responsive"
import IntegrationSection from "./IntegrationSection"
import AboutSection from "./AboutSection"
import HowItWorksSection from "./HowItWorksSection"
import SolutionSection from "./SolutionSection"

const { Option } = Select

const MainHeader = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })
  const [accountInfo, setAccountInfo] = useState([])

  useEffect(() => {
    Request("accounts/account_details", "GET")
      .then((response) => {
        if (response.account_details) setAccountInfo(response.account_details)
      })
      .catch(({ errors }) => {
        console.log("errors from catch: ", errors)
        
      })
  }, [])

  return (
    <>
      <div className="header-background"></div>
      <Row
        style={{
          minHeight: !isMobileScreen ? "100vh" : "auto",
          paddingTop: !isMobileScreen ? '100px' : ""
        }}
      >
        <Col span={24} style={{ height: "100%" }}>
          <Row gutter={{ lg: 16 }} style={{ height: "100%" }}>
            <Col span={24} lg={24} style={{ zIndex: 1 }}>
              <IntegrationSection />
              {/* <AboutSection /> */}
              <HowItWorksSection />
              <SolutionSection />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
  
}

export default MainHeader
